import { Component, Output, EventEmitter, DebugElement, OnInit } from '@angular/core';
import { TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import { FormBuilder, FormGroup, Validators, FormsModule,FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { LoginDialogComponent } from 'app/modules/dialogs/login-dialog/login-dialog.component';
import { DialogUtilsService } from 'app/modules/utils/dialog-utility.service';
import { finalize, firstValueFrom } from 'rxjs';
import { Subject, Subscription } from 'rxjs';
import { UserExistComponent } from '../existent_user/user_exists.component';
import { FerrerAuthService } from 'app/services/authentication.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common'; // Add this import
import { RegisterService } from 'app/services/register.service';
import { PassConsentMissingComponent } from '../pass_consent_missing-step/pass_consent_missing.component';
import { NavigationFlowService } from 'app/services/navigation-flow.service';
@Component({
  selector: 'app-email-step',
  templateUrl: './email-step.component.html',
  imports: [
    TranslocoPipe,
    FormsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    CommonModule,
    ReactiveFormsModule
  ],
})
export class EmailStepComponent implements OnInit{
  @Output() next = new EventEmitter<string>();
  @Output() navigateToPassconsent = new EventEmitter<{ email: string, veevaInfo: any }>();
  email = '';
  isSubmitting = false;
  registerForm: FormGroup;
  emailError = '';
  private emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  private subscriptions: Subscription[] = [];
  private destroy$ = new Subject<void>();
  
  private resizeListener: (() => void) | null = null;
  constructor(
    private translocoService: TranslocoService,
    private _dialogRef: MatDialogRef<any>,
    private _dialog: MatDialog,
    private dialogUtilsService: DialogUtilsService,
    private ferrerAuthService: FerrerAuthService,
    private registerService: RegisterService,
    private fb: FormBuilder,
    private navigationFlow: NavigationFlowService
  ) {}
    
  changeLang(lang: string) {
    this.translocoService.setActiveLang(lang);
  }

  ngOnDestroy(): void {
    // Clean up all subscriptions when component is destroyed
    this.subscriptions.forEach(sub => sub?.unsubscribe());
    this.subscriptions = [];
    
    // Notify all takeUntil operators
    this.destroy$.next();
    this.destroy$.complete();
    
    // Clean up any other resources
    if (this.resizeListener) {
      this.resizeListener();
    }
  }

  get emailControl() {
    return this.registerForm.get('email');
  }
  ngOnInit(): void {
    // Create the form with validators
    this.registerForm = this.fb.group({
      email: ['', [
        Validators.required,
        Validators.email,
        EmailStepComponent.noWhitespaceValidator
      ]]
    });
  }
  continue() {
    this.emailError = '';
    this.registerForm.markAllAsTouched();
     if (this.registerForm.invalid) {
      return;
    }

    const email = this.emailControl.value;
    this.email = email;
    // Set loading state
    this.isSubmitting = true;
    // this.next.emit(this.email);
    const emailSub = this.ferrerAuthService.verifiedEmail(email).pipe(
    ).subscribe({
      next: (response: any) => {
        
        // Handle the response properly
        if(response.connect === false){
          //check for veeva
          this.loadveevainfo();
          
        }else{
          this.isSubmitting = false;
          this.accountExistDialog();
        }
      },
      error: (error) => {
        this.isSubmitting = false;
      }
    });
    this.subscriptions.push(emailSub);
    
  }


  closeDialog(): void {
    this.navigationFlow.closeCurrentDialog();
  }
  accountExistDialog(): void {
    if (this._dialogRef) {
      // Close without animation
      this._dialogRef.close();
    }

    const { width, height } = this.dialogUtilsService.calculateDialogSize();

    this._dialogRef = this._dialog.open(UserExistComponent, {
      width: `${width}px`,
      //height: `${height+100}px`,
      maxWidth: '90vw',
      maxHeight: '80vh',
      autoFocus: false,
      disableClose: true,
      panelClass: 'custom-dialog-panel',
      // Disable enter animation
      enterAnimationDuration: '0ms',
      // Disable exit animation
      exitAnimationDuration: '0ms',
      data: {
        email: this.email
      }
    });

    // Set up responsive behavior and get cleanup function
    const cleanupResizeListener = this.dialogUtilsService.setupResponsiveDialog(this._dialogRef);

    this._dialogRef.afterClosed().subscribe(() => {
      // Clean up the event listener
      cleanupResizeListener();
      this._dialogRef = null;
    });
  }
  async backLoginDialog(): Promise<void> {
    // Use NavigationFlowService to transition from register to login dialog
    // This will close the current register dialog and open login with proper transition
    await firstValueFrom(this.navigationFlow.transitionRegisterToLogin());
  }

  loadveevainfo(): void{
    this.registerService.checkUserVeevaInfo(this.email).subscribe({
      next: (veevaInfo) => {
        this.isSubmitting = false;
        if (veevaInfo && Object.keys(veevaInfo).length > 0) {
        // Pre-populate form with Veeva data
        const formUpdates: any = {
          firstName: veevaInfo.firstName || '',
          lastName: veevaInfo.name || '',  
          profession: veevaInfo.profession || '',
          country: veevaInfo.country || '',
          postalCode: veevaInfo.postalCode || ''
        };
        
        this.goToPassconsent(veevaInfo);
        //this.openpassConsentMissingDialog(veevaInfo);
      }
    },
      error: (error) => {
        this.isSubmitting = false;
        this.next.emit(this.email);
      }
    });
  }

  goToPassconsent(veevainfo: any): void{
    this.navigateToPassconsent.emit({
      email: this.email,
      veevaInfo: veevainfo
    });
  }
  shouldShowCloseButton(): boolean {
   return true;
  }
  openpassConsentMissingDialog(veevaInfo: any): void {
    // Close any existing dialog
      if (this._dialogRef) {
        // Close without animation
        this._dialogRef.close();
      }
    
      const { width, height } = this.dialogUtilsService.calculateDialogSize();
    
      this._dialogRef = this._dialog.open(PassConsentMissingComponent, {
        width: `${width}px`,
        //height: `${height}px`,
        maxWidth: '90vw',
        maxHeight: '90vh',
        autoFocus: false,
        disableClose: true,
        panelClass: 'custom-dialog-panel',
        // Disable enter animation
        enterAnimationDuration: '0ms',
        // Disable exit animation
        exitAnimationDuration: '0ms',
        data: {
          email: this.email,
          veevainfo: veevaInfo
        }
      });
    
      // Set up responsive behavior and get cleanup function
      const cleanupResizeListener = this.dialogUtilsService.setupResponsiveDialog(this._dialogRef);
    
      const dialogCloseSub = this._dialogRef.afterClosed().subscribe(() => {
        // Clean up the event listener
        cleanupResizeListener();
        this._dialogRef = null;
      });
      this.subscriptions.push(dialogCloseSub);
    }

    static noWhitespaceValidator(control: FormControl): {[key: string]: boolean} | null {
      const containsSpaces = (control.value || '').includes(' ');
      return containsSpaces ? { 'containsSpaces': true } : null;
    }
}